import api from './apiClient'

export default {
    getTestStatus: async () => await api.get('systemTest/test-status'),
    getTestKey: async () => await api.get('systemTest/test-key'),
    placeOnTest: async data => await api.post('systemTest/place', data),
    extendTest: async data => await api.post('systemTest/extend', data),
    clearTest: async () => await api.post('systemTest/clear')
}